import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

export class QuestionMark extends PureComponent {
  render() {
    return (
      <Icon width={18} height={18}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill={this.props.fill || "#FFFFFF"}>
            <path d="M9,0 C4.029,0 0,4.029 0,9 C0,13.971 4.029,18 9,18 C13.971,18 18,13.971 18,9 C18,4.029 13.971,0 9,0 M9,2 C12.859,2 16,5.141 16,9 C16,12.859 12.859,16 9,16 C5.141,16 2,12.859 2,9 C2,5.141 5.141,2 9,2 M7.8066,12.9814 C7.8066,12.6824 7.9096,12.4364 8.1136,12.2414 C8.3166,12.0474 8.5776,11.9504 8.8956,11.9504 C9.2136,11.9504 9.4746,12.0474 9.6786,12.2414 C9.8826,12.4364 9.9846,12.6824 9.9846,12.9814 C9.9846,13.2764 9.8846,13.5194 9.6856,13.7114 C9.4866,13.9034 9.2226,14.0004 8.8956,14.0004 C8.5686,14.0004 8.3056,13.9034 8.1066,13.7114 C7.9076,13.5194 7.8066,13.2764 7.8066,12.9814 Z M8.0016,10.9214 C8.0016,10.2934 8.0776,9.7934 8.2306,9.4214 C8.3826,9.0484 8.6616,8.6824 9.0676,8.3224 C9.4726,7.9604 9.7426,7.6674 9.8766,7.4404 C10.0116,7.2144 10.0786,6.9744 10.0786,6.7234 C10.0786,5.9654 9.7296,5.5854 9.0306,5.5854 C8.6986,5.5854 8.4336,5.6874 8.2336,5.8924 C8.0346,6.0964 7.9306,6.3784 7.9206,6.7374 L5.9726,6.7374 C5.9816,5.8814 6.2576,5.2104 6.8026,4.7264 C7.3466,4.2424 8.0896,4.0004 9.0306,4.0004 C9.9806,4.0004 10.7166,4.2294 11.2416,4.6904 C11.7656,5.1494 12.0276,5.7984 12.0276,6.6364 C12.0276,7.0184 11.9426,7.3774 11.7726,7.7164 C11.6016,8.0554 11.3036,8.4304 10.8776,8.8424 L10.3336,9.3614 C9.9936,9.6884 9.7986,10.0724 9.7486,10.5114 L9.7226,10.9214 L8.0016,10.9214 Z" />
          </g>
        </g>
      </Icon>
    );
  }
}

QuestionMark.vstuiName = "Icon";

export const MultiColorCovers = props => (
  <svg
    width="212"
    height="113"
    viewBox="0 0 212 113"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
    {...props}
  >
    <defs>
      <polygon points="0 113 212.410612 113 212.410612 0.329748538 0 0.329748538" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-12 -67)">
        <g transform="translate(11.5 67)">
          <polygon
            fill="#FEC391"
            points="206.694091 66.3034224 203.5 65.6717446 205.336101 67.6569282 204.220725 69.3797997 207.278305 69.3034224 209.783373 71 209.835777 68.9678631 212.5 68.2936144 209.475415 67.1135225 208.616886 65"
          />
          <polygon
            fill="#FEC391"
            points="137.317764 4 139.296248 6.1358085 142.5 5.85637518 140.70758 8.2377463 141.885299 10.8001954 138.798698 10.1358085 136.322665 12 136.20758 9.20827227 133.5 7.79677577 136.514931 6.7357108"
          />
          <polygon
            fill="#75CFEC"
            points="65.469465 99 67.0084313 100.869245 69.5 100.624309 68.10587 102.707958 69.0214657 104.951052 66.6211375 104.368906 64.6955154 106 64.606189 103.557429 62.5 102.321896 64.8454562 101.393719"
          />
          <polygon
            fill="#86E0C2"
            points="4.47619386 40.5542364 1.49516771 39.0402436 2.45004264 42.2860998 0.5 44.6028834 3.6716174 45.0538894 5.44705799 48 6.45245878 45.0337676 9.5 44.5362732 6.95004264 42.2527947 7.05749005 39"
          />
          <polygon
            fill="#75CFEC"
            points="39.2400607 0 36.5233297 1.97009267 33.0604638 1.04254423 34.4409166 4.01032013 32.5 6.6053075 36.0698509 6.46946083 38.3344837 9 39.1606847 5.94882056 42.5 4.91828138 39.4402264 3.16743892"
          />
          <polygon
            fill="#75CFEC"
            points="183.062655 103 183.294045 105.478549 185.5 106.932282 183.175558 107.641978 182.680521 110 181.013027 107.961139 178.5 107.965179 179.794045 105.994998 178.736352 103.638996 181.203474 104.461139"
          />
          <path
            d="M51,105 L51,112"
            stroke="#DADADA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M53.5,108.5 L48.5,108.5"
            stroke="#DADADA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M125,1 L125,8"
            stroke="#DADADA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M127.5,4.5 L122.5,4.5"
            stroke="#DADADA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M163,97 L163,104"
            stroke="#DADADA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M165.5,100.5 L160.5,100.5"
            stroke="#DADADA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <g transform="translate(.5)">
            <path
              d="M193.004923,90.9717404 L143.137125,90.9717404 C141.307441,90.9717404 139.823718,89.489524 139.823718,87.6616994 L139.823718,22.1686175 C139.823718,20.3401322 141.307441,18.8585766 143.137125,18.8585766 L193.004923,18.8585766 C194.835267,18.8585766 196.318991,20.3401322 196.318991,22.1686175 L196.318991,87.6616994 C196.318991,89.489524 194.835267,90.9717404 193.004923,90.9717404"
              fill="#FFF"
            />
            <path
              d="M193.004923,90.9717404 L143.137125,90.9717404 C141.307441,90.9717404 139.823718,89.489524 139.823718,87.6616994 L139.823718,22.1686175 C139.823718,20.3401322 141.307441,18.8585766 143.137125,18.8585766 L193.004923,18.8585766 C194.835267,18.8585766 196.318991,20.3401322 196.318991,22.1686175 L196.318991,87.6616994 C196.318991,89.489524 194.835267,90.9717404 193.004923,90.9717404 Z"
              stroke="#DADADA"
              strokeWidth="2"
            />
            <polygon
              fill="#0093C4"
              points="144.762606 85.9923392 191.379839 85.9923392 191.379839 23.8370526 144.762606 23.8370526"
            />
            <polygon
              fill="#00A7DB"
              points="191.379905 85.9923392 144.762672 85.9923392 144.762672 53.1846725 191.379905 62.4215965"
            />
            <polygon
              fill="#3BBAE3"
              points="144.762473 85.9923392 191.379706 85.9923392 191.379706 53.1846725 144.762473 62.4215965"
            />
            <polygon
              fill="#75CFEC"
              points="144.762473 85.9923392 191.379706 85.9923392 191.379706 67.5528538 144.762473 76.789117"
            />
            <polygon
              fill="#B0E3F4"
              points="191.379905 85.9923392 144.762672 85.9923392 144.762672 67.5528538 191.379905 76.789117"
            />
            <path
              d="M129.670696,90.9717404 L79.8028975,90.9717404 C77.9732143,90.9717404 76.4894907,89.489524 76.4894907,87.6616994 L76.4894907,22.1686175 C76.4894907,20.3401322 77.9732143,18.8585766 79.8028975,18.8585766 L129.670696,18.8585766 C131.500379,18.8585766 132.984102,20.3401322 132.984102,22.1686175 L132.984102,87.6616994 C132.984102,89.489524 131.500379,90.9717404 129.670696,90.9717404"
              fill="#FFF"
            />
            <path
              d="M129.670696,90.9717404 L79.8028975,90.9717404 C77.9732143,90.9717404 76.4894907,89.489524 76.4894907,87.6616994 L76.4894907,22.1686175 C76.4894907,20.3401322 77.9732143,18.8585766 79.8028975,18.8585766 L129.670696,18.8585766 C131.500379,18.8585766 132.984102,20.3401322 132.984102,22.1686175 L132.984102,87.6616994 C132.984102,89.489524 131.500379,90.9717404 129.670696,90.9717404 Z"
              stroke="#DADADA"
              strokeWidth="2"
            />
            <polygon
              fill="#F58525"
              points="81.4281801 85.9923392 128.045413 85.9923392 128.045413 23.8370526 81.4281801 23.8370526"
            />
            <polygon
              fill="#FE9840"
              points="128.045545 85.9923392 81.4283124 85.9923392 81.4283124 53.1846725 128.045545 62.4215965"
            />
            <polygon
              fill="#FEAD64"
              points="81.4282463 85.9923392 128.045479 85.9923392 128.045479 53.1846725 81.4282463 62.4215965"
            />
            <polygon
              fill="#FEC391"
              points="81.4282463 85.9923392 128.045479 85.9923392 128.045479 67.5528538 81.4282463 76.789117"
            />
            <polygon
              fill="#FEDBBD"
              points="128.045545 85.9923392 81.4283124 85.9923392 81.4283124 67.5528538 128.045545 76.789117"
            />
            <path
              d="M66.3364686,90.9717404 L16.4686705,90.9717404 C14.6389873,90.9717404 13.1552637,89.489524 13.1552637,87.6616994 L13.1552637,22.1686175 C13.1552637,20.3401322 14.6389873,18.8585766 16.4686705,18.8585766 L66.3364686,18.8585766 C68.1668134,18.8585766 69.6498755,20.3401322 69.6498755,22.1686175 L69.6498755,87.6616994 C69.6498755,89.489524 68.1668134,90.9717404 66.3364686,90.9717404"
              fill="#FFF"
            />
            <path
              d="M66.3364686,90.9717404 L16.4686705,90.9717404 C14.6389873,90.9717404 13.1552637,89.489524 13.1552637,87.6616994 L13.1552637,22.1686175 C13.1552637,20.3401322 14.6389873,18.8585766 16.4686705,18.8585766 L66.3364686,18.8585766 C68.1668134,18.8585766 69.6498755,20.3401322 69.6498755,22.1686175 L69.6498755,87.6616994 C69.6498755,89.489524 68.1668134,90.9717404 66.3364686,90.9717404 Z"
              stroke="#DADADA"
              strokeWidth="2"
            />
            <polygon
              fill="#1FB380"
              points="18.0937547 85.9923392 64.7109876 85.9923392 64.7109876 23.8370526 18.0937547 23.8370526"
            />
            <polygon
              fill="#23C991"
              points="64.7113183 85.9923392 18.0940854 85.9923392 18.0940854 53.1846725 64.7113183 62.4215965"
            />
            <polygon
              fill="#55D5A9"
              points="18.0939531  85.9923392 64.711186 85.9923392 64.711186 53.1846725 18.0939531 62.4215965"
            />
            <polygon
              fill="#86E0C2"
              points="18.0939531 85.9923392 64.711186 85.9923392 64.711186 67.5528538 18.0939531 76.789117"
            />
            <polygon
              fill="#C0EADB"
              points="64.7113183 85.9923392 18.0940854 85.9923392 18.0940854 67.5528538 64.7113183 76.789117"
            />
            <polygon
              fill="#86E0C2"
              points="193.189479 81.6850567 196.834954 86.8169749 203.786559 87.3165538 199.27387 91.6845655 201.081724 97.4363316 194.646743 95.0045187 188.813056 98.0601444 189.348202 92.1887702 183.935224 88.3249632 190.700951 87.1288813"
            />
            <polygon
              fill="#FEC391"
              points="12.0144568 3.82528129 17.5207053 11.2099304 26.6036339 10.8299596 21.4228388 18.3844392 24.6416525 27.042486 15.9337891 24.3258602 8.83996304 30.0571409 8.63886988 20.8235211 1.03569596 15.7081234 9.61986056 12.7179187"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
